// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Action imports
import { setScatterPlot } from 'ChartApp/ts/apps/scatter-plot/state/scatter-plot.actions';
import { setXAxisMetric } from './x-axis-metric.actions';
export const xAxisMetric = createReducer('', on(setScatterPlot, (state, action) => {
    return action.scatterPlot.xAxisMetric;
}), on(setXAxisMetric, (state, action) => {
    return action.metricId;
}));
